<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <div class="d-flex flex-wrap">
                    <div class="col-12 col-md-6">
                        <!-- image -->
                        <div role="group" class="form-group">
                            <label class=""> {{ $t('imageMandatory') }}</label>
                            <GalleryPicker class="gallery-picker" v-model="hero.image" :ratioWidth="16" :ratioHeight="9" v-bind:class="{ 'is-invalid': genericValidator(hero.image, attemptedSubmit) === false || errorValidator('Image') === false }" :max="1"></GalleryPicker>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <!-- Contents -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('contentMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="hero.contents[currentLanguage.key]" :invalid-feedback="errorOutput['Contents']" :is-valid="genericValidator(hero.contents, attemptedSubmit) && errorValidator('Contents')"></CInput>
                        </div>
                        <!-- ButtonText -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('buttonContentMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="hero.buttonTexts[currentLanguage.key]" :invalid-feedback="errorOutput['ButtonTexts']" :is-valid="genericValidator(hero.buttonTexts, attemptedSubmit) && errorValidator('ButtonTexts')"></CInput>
                        </div>                
                        <!-- ButtonUrl -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('buttonUrlMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="hero.url" :invalid-feedback="errorOutput['ButtonUrl']" :is-valid="genericValidator(hero.url, attemptedSubmit) && errorValidator('ButtonUrl')"></CInput>
                        </div>  
                    </div>
                </div>
              <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router/index';

import { API_HELPER } from "@/helpers/api.js";
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";

import InputGetList from "@/classes/InputGetList";
import Hero from "@/classes/Hero";

import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import GalleryPicker from '@/controls/GalleryPicker.vue'
import { VueEditor } from "vue2-editor";
import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, SingleOptionDropdown, VueEditor, GalleryPicker, OptionsDropdown, FormLoading },
    props:{    
        baseHero:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            hero: new Hero({},{}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetHero();
    },
    computed:
    {
        ...mapState('hero', ['putHeroOutput']),
        ...mapState('hero', ['postHeroOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.hero.contents)) { if(!value) { result['Contents'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.hero.buttonTexts)) { if(!value) { result['ButtonTexts'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.baseHero || this.baseName ? (this.baseHero ? this.baseHero.name : this.baseName) : null;
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetHero(){
            if(!this.baseHero)
            {
                var contents = {}; var buttonTexts = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { contents[language.key] = ""; buttonTexts[language.key] = ""; });
                this.hero = new Hero(contents, buttonTexts);
            }
            else
            {
                this.hero = deepClone(new Hero, this.baseHero);    
                // image
                this.hero.image = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.hero.imagePath]), path: this.hero.imagePath};
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.hero.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.hero);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: "Hero"});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putHeroOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postHeroOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseHero: function()
        {
            this.resetHero();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style> 